import { c } from 'react-compiler-runtime';
import { clsx } from 'clsx';
import classes from './BaseStyles.module.css.js';
import 'focus-visible';
import { jsx } from 'react/jsx-runtime';

function BaseStyles(t0) {
  const $ = c(20);
  let children;
  let className;
  let color;
  let rest;
  let style;
  let t1;
  if ($[0] !== t0) {
    ({
      children,
      color,
      className,
      as: t1,
      style,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = color;
    $[4] = rest;
    $[5] = style;
    $[6] = t1;
  } else {
    children = $[1];
    className = $[2];
    color = $[3];
    rest = $[4];
    style = $[5];
    t1 = $[6];
  }
  const Component = t1 === undefined ? "div" : t1;
  let t2;
  if ($[7] !== className) {
    t2 = clsx(classes.BaseStyles, className);
    $[7] = className;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  const newClassName = t2;
  let t3;
  if ($[9] !== color) {
    t3 = {
      "--BaseStyles-fgColor": color
    };
    $[9] = color;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  const baseStyles = t3;
  let t4;
  if ($[11] !== baseStyles || $[12] !== style) {
    t4 = {
      ...baseStyles,
      ...style
    };
    $[11] = baseStyles;
    $[12] = style;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  let t5;
  if ($[14] !== Component || $[15] !== children || $[16] !== newClassName || $[17] !== rest || $[18] !== t4) {
    t5 = /*#__PURE__*/jsx(Component, {
      className: newClassName,
      "data-portal-root": true,
      style: t4,
      ...rest,
      children: children
    });
    $[14] = Component;
    $[15] = children;
    $[16] = newClassName;
    $[17] = rest;
    $[18] = t4;
    $[19] = t5;
  } else {
    t5 = $[19];
  }
  return t5;
}

export { BaseStyles as default };
